// import { render_searchBar } from "./address-search";
import { render_maps } from "./render-maps";
import {
  render_candidates,
  render_list,
  candidates,
  ald_list,
  pd_list,
  list_toggles,
} from "./render-candidates";

const init_page = () => {
  // const urlSearchParams = new URLSearchParams(window.location.search);
  // const params = Object.fromEntries(urlSearchParams.entries());

  // d3.select(".clear-btn-container")
  //   .append("button")x
  //   .text("Clear all")
  //   .on("click", () => {});

  const clearAll = () => {
    d3.select("#candidate-search #autocomplete input").node().value = null;
    d3.select("option.ward-default").property("selected", true);
    d3.select("option.precinct-default").property("selected", true);
    sel.ward = null;
    sel.precinct = null;
    d3.select(".you-are-here").text(null);
    render_maps();
    candidates.select(".ald_dropdown").text("See all 50 wards");
    candidates.select(".pd_dropdown").text("See all 22 police districts");
    list_toggles.pd = false;
    list_toggles.ald = false;
    render_candidates();
  };

  const showAll = () => {
    list_toggles.pd = true;
    list_toggles.ald = true;
    render_list(
      ald_list,
      ward_nums,
      true,
      { text: "Ward", val: "ward" },
      ward_data
    );
    render_list(
      pd_list,
      police_dist_nums,
      true,
      { text: "Police Department", val: "pd" },
      pd_data
    );
    candidates.select(".ald_dropdown").text("See less");
    candidates.select(".pd_dropdown").text("See less");
  };

  let clear = true;

  d3.select(".clear-btn-container")
    .append("button")
    .text("Clear results")
    .on("click", () => {
      clear = true;
      clrBtn.text("Expand all");
      clearAll();
    });

  const clrBtn = d3
    .select(".clear-btn-container")
    .append("button")
    .text("Expand all")
    .on("click", () => {
      clear = !clear;
      clrBtn.text(clear ? "Expand all" : "Close All");
      return clear ? clearAll() : showAll();
    });

  // if (params) {
  //   sel.ward = +params.ward;
  //   sel.precinct = +params["police-district"];
  //   if (sel.ward)
  //     ward_select.select(`option.ward_${sel.ward}`).property("selected", true);
  //   if (sel.precinct)
  //     precinct_select
  //       .select(`option.police-district_${sel.precinct}`)
  //       .property("selected", true);
  //   render_candidates();
  // }
  render_candidates();
};

init_page();
